<template>
  <label :class="labelclass" @click="show = !show">
    {{ labelvalue }}<span v-if="isRequiredLabel == true">*</span
    ><i class="fa fa-info-circle ml-1" v-tooltip.bottom ="{ value: tooltipvalue, showDelay: 1000, hideDelay: 300 }"></i>
    <br v-if="labelvaluesmall !== '' && labelvaluesmall !== null" />
    <small v-if="labelvaluesmall !== '' && labelvaluesmall !== null">
      {{ labelvaluesmall }}
    </small>
  </label>
</template>

<script>
export default {
  props: {
    labelvalue: {
      type: String,
      default: "",
    },
    labelvaluesmall: {
      type: String,
      default: "",
    },
    labelclass: {
      type: String,
      default: "",
    },
    labelfor: {
      type: String,
      default: "",
    },
    tooltipvalue: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    isRequiredLabel: {
      type: Boolean,
      default: false,
    },
    smalltextnewline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    let _this = this;
    window.addEventListener("mousedown", function () {
      _this.show = false;
    });
  },
};
</script>